// extracted by mini-css-extract-plugin
module.exports = {"bubble":"styles_bubble__1xRJ5"};